import {HttpErrorResponse} from '@angular/common/http';

/**
 * 403-Antwort des Backends für SSO-Gast-Accounts (webabo-core: GuestAccountException).
 *
 * Erkannt wird ausschließlich der maschinenlesbare `errorCode` — nie der Meldungstext, der sich
 * jederzeit ändern darf. Der Body hat die Form `{url, message, errorCode}` und entspricht damit
 * NICHT dem Schema von `ErrorResponse`.
 */
export class GuestAccountError {
  static readonly ERROR_CODE = 'GUEST_ACCOUNT_FORBIDDEN';

  static isGuestAccountError(error: unknown): boolean {
    if (!(error instanceof HttpErrorResponse) || error.status !== 403) {
      return false;
    }
    const body = error.error as unknown;
    if (!body || typeof body !== 'object') {
      return false;
    }
    return (body as { errorCode?: unknown }).errorCode === GuestAccountError.ERROR_CODE;
  }
}
